import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 14.012c.99 0 2.076.144 3.257.431 1.342.335 2.428.783 3.258 1.341.99.655 1.485 1.39 1.485 2.204V20H4v-2.012c0-.814.495-1.549 1.485-2.204.83-.558 1.916-1.006 3.258-1.34 1.181-.288 2.267-.432 3.257-.432zM12 12c-.719 0-1.381-.18-1.988-.539a4.075 4.075 0 01-1.45-1.449 3.845 3.845 0 01-.538-1.988c0-.719.18-1.39.539-2.012a4.007 4.007 0 011.449-1.473A3.827 3.827 0 0112 4c.719 0 1.381.18 1.988.539.607.36 1.09.85 1.45 1.473a3.97 3.97 0 01.538 2.012c0 .719-.18 1.381-.539 1.988a4.075 4.075 0 01-1.449 1.45A3.845 3.845 0 0112 12z"
      />
    </svg>
  );
}

export default tombacIcon('User')(SvgUser);
